
export const operationHours = [
    {
        day: "Monday",
        is_open: false,
        start: null,
        end: null,
    },
    {
        day: "Tuesday",
        is_open: false,
        start: null,
        end: null,
    },
    {
        day: "Wednesday",
        is_open: false,
        start: null,
        end: null,
    },
    {
        day: "Thursday",
        is_open: false,
        start: null,
        end: null,
    },
    {
        day: "Friday",
        is_open: false,
        start: null,
        end: null,
    },
    {
        day: "Saturday",
        is_open: false,
        start: null,
        end: null,
    },
    {
        day: "Sunday",
        is_open: false,
        start: null,
        end: null,
    },
];